import React from "react";
import Cart from "../../Assets/cart.png";
import "./cartButton.scss";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";

const CartButton = ({ experience }) => {
  const { restaurant, id, table } = useParams();
  const cart = useSelector((state) => state?.user.cart);
  const lines = Object.values(cart || {});
  const count = lines.reduce((sum, line) => sum + Number(line?.selected || 0), 0);
  if (count === 0) return null;
  const isTakeaway = experience === "takeaway";
  const cartPath = isTakeaway
    ? `/${restaurant}/${id}/takeaway/cart`
    : `/${restaurant}/${id}/${table}/cart`;
  const total = lines.reduce((sum, line) => {
    const price = Number(line?.variant?.price ?? line?.price ?? 0);
    return sum + price * Number(line?.selected || 0);
  }, 0);

  if (isTakeaway) {
    return (
      <div className="cartContainer takeaway-cart-dock">
        <Link to={cartPath} className="cartLink takeaway-cart-link" aria-label="View cart">
          <span className="takeaway-cart-summary">
            <strong>{count} {count === 1 ? "item" : "items"}</strong>
            <small>₹{total.toFixed(2)}</small>
          </span>
          <span className="takeaway-cart-action">View order</span>
        </Link>
      </div>
    );
  }

  return (
    <div className="cartContainer">
      <Link to={cartPath} className="cartLink">
        <div className="iconContainer">
          <img src={Cart} alt="cart" className="cartIcon" />
          <div className="count">{count}</div>
        </div>
        <span className="viewCartText">View cart</span>
      </Link>
    </div>
  );
};

export default CartButton;
